export default __webpack_public_path__ + "static/media/Pamoda.dfbe3a7f.jpg";